var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#investmentSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.165 10.5a1.5 1.5 0 0 0-1.5-1.5H31a1.5 1.5 0 0 0 0 3h2.046c-2.724 2.531-5.297 4.222-8.125 5.408-3.657 1.534-7.845 2.268-13.55 2.764a1.5 1.5 0 0 0 .26 2.989c5.796-.504 10.357-1.27 14.45-2.986 3.243-1.36 6.127-3.288 9.085-6.05v2.042a1.5 1.5 0 1 0 3 0V10.5ZM33 20.666a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1h-3ZM25 24.666a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-14ZM19 25.666a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1h-3ZM12 28.666a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-3Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "investmentSvg",
    x1: 0,
    y1: 0.265,
    x2: 49.218,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/Investment.836a02d1a4550ba38684ff0f8b306b14.svg";
export { ForwardRef as ReactComponent };